import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchAuthCheck } from '../api/auth';
import { fetchUser } from '../api/user';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [user, setUser] = useState(null);

    const fetchUserData = useCallback(async () => {
        try {
            const data = await fetchUser();
            setUser(data);
            return data;
        } catch (error) {
            console.error('Profile fetch error:', error);
            setUser(null);
        }
    }, []);

    useEffect(() => {
        if (isAuthenticated) {
            fetchUserData();
        }
    }, [fetchUserData, isAuthenticated]);

    const checkAuthStatus = useCallback(async () => {
        try {
            const response = await fetchAuthCheck();
            setIsAuthenticated(response.ok);
        } catch (error) {
            setIsAuthenticated(false);
            setUser(null);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        checkAuthStatus();
    }, [checkAuthStatus]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, isLoading, user }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
